// Motion utilities for accessibility
import {gsap} from 'gsap'

/**
 * Check if user prefers reduced motion
 */
export const prefersReducedMotion = (): boolean => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }
  return false
}

/**
 * Configure GSAP for reduced motion
 */
export const configureReducedMotion = (): void => {
  if (prefersReducedMotion()) {
    // Disable all GSAP animations globally
    gsap.globalTimeline.timeScale(0)

    // Alternative: Make all animations instant
    // gsap.defaults({
    //   duration: 0.01,
    //   ease: "none"
    // });
  }
}

/**
 * Create a timeline that respects motion preferences
 */
export const createAccessibleTimeline = (vars?: gsap.TimelineVars): gsap.core.Timeline => {
  const timeline = gsap.timeline(vars)

  if (prefersReducedMotion()) {
    // Make timeline instant but keep the sequence
    timeline.timeScale(1) // Very fast instead of completely disabled
  }

  return timeline
}

/**
 * Animation helper that respects motion preferences
 */
export const accessibleTo = (target: any, vars: gsap.TweenVars): gsap.core.Tween => {
  if (prefersReducedMotion()) {
    // Instant animation - set final values immediately
    return gsap.set(target, vars)
  }
  return gsap.to(target, vars)
}

export const accessibleFromTo = (target: any, fromVars: gsap.TweenVars, toVars: gsap.TweenVars): gsap.core.Tween => {
  if (prefersReducedMotion()) {
    // Set to final state immediately
    return gsap.set(target, toVars)
  }
  return gsap.fromTo(target, fromVars, toVars)
}
